module.exports = __webpack_public_path__ + "static/img/1.923cbf3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/partner/1.png
// module id = T7ML
// module chunks = 45